<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('manage.boats')">Boats</inertia-link>
            <span class="text-indigo-400 font-medium">/</span> Update
        </h1>
        <div class="bg-white rounded shadow overflow-hidden max-w-3xl">
            <form @submit.prevent="submit">
                <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

                  <text-input v-model="form.name" :errors="$page.props.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Boat Name" />
                  <text-input v-model="form.alt_name" :errors="$page.props.errors.alt_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Alternative Name" />

                  <select-input v-model="form.atoll" :errors="$page.props.errors.atoll" class="pr-6 pb-8 w-full lg:w-1/2" label="Atoll">
                    <option :value="null" />
                    <option v-for="(atoll, aindx) in atoll_list" :value="atoll" :key="aindx">{{ atoll }}</option>
                  </select-input>
                  <text-input v-model="form.primary_mobile" :errors="$page.props.errors.primary_mobile" class="pr-6 pb-8 w-full lg:w-1/2" label="Primary Mobile Number" />
                  <text-input v-model="form.secondary_mobile" :errors="$page.props.errors.secondary_mobile" class="pr-6 pb-8 w-full lg:w-1/2" label="Secondary Mobile Number" />

                  <div class="flex items-center justify-between border-b py-3">
                    <toggle v-model="form.approved" class="mr-2" />
                    <div class="text-sm font-medium" v-if="form.approved">Approved</div>
                    <div class="text-sm font-medium" v-else>Not Approved</div>
                  </div>

                </div>

                <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex justify-between items-center">
                    <loading-button :loading="sending" class="btn-red" type="button" @click="deleteBoat">Delete Boat</loading-button>
                    <loading-button :loading="sending" class="btn-primary" type="submit">Update Boat</loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

  import Layout from '@/Shared/Admin/Layout'
  import LoadingButton from '@/Shared/LoadingButton'
  import SelectInput from '@/Shared/SelectInput'
  import TextInput from '@/Shared/TextInput'
  import Toggle from '@/Shared/Toggle'

  export default {
    metaInfo: { title: 'Create Warehouse' },
    layout: Layout,
    components: {
      LoadingButton,
      SelectInput,
      TextInput,
      Toggle
    },
    props: {
      boat: {
        type: Object,
        required: true
      },
      atoll_list: {
        type: Array
      }
    },
    remember: 'form',
    data() {
      return {
        sending: false,
        form: {
          name: this.boat.name,
          alt_name: this.boat.alt_name,
          atoll: this.boat.atoll || null,
          primary_mobile: this.boat.primary_mobile || null,
          secondary_mobile: this.boat.secondary_mobile || null,
          approved: this.boat.approved == true
        },
      }
    },

    methods: {
      submit() {
        this.sending = true
        this.$inertia.put(this.route('manage.boats.update', this.boat.id), this.form,{
          onFinish : () => this.sending = false
        })
      },
      deleteBoat() {
        this.sending = true
        if (confirm('Are you sure you want to delete this boat?')) {
          this.$inertia.delete(this.route('manage.boats.destroy', this.boat.id),{
            onFinish : () => this.sending = false
          })
        } else {
          this.sending = false
        }
      }
    },
  }
</script>

